import { ViewerContext } from "dash-ui";
import { useContext } from "react";

const REST_API_DOMAIN = process.env["REACT_APP_REST"];

interface ILinkToCustomerPortalProps {
  className?: string;
  children?: React.ReactNode;
}

export default function LinkToCustomerPortal({
  className,
  children,
}: ILinkToCustomerPortalProps) {
  const { account } = useContext(ViewerContext);

  return (
    <a
      className={`hover:opacity-90 ${className}`}
      href={`${REST_API_DOMAIN}/stripe/create-portal-session?customerId=${account?.stripeCustomerId}`}>
      {children}
    </a>
  );
}